<template functional>
  <a :class="[data.class, data.staticClass]" :href="`mailto:${props.address}`" v-on="listeners">
    <template v-if="!children">
      {{ props.address }}
    </template>
    <slot />
  </a>
</template>

<script>
export default {
  props: {
    address: String,
  },
}
</script>
